import { UseForm } from '@brenger/react';
import * as React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import { InputCheckbox, InputPassword, InputText } from '../../../../brenger-shared-ui';
import { getActiveLanguageSettings, translate } from '../../../../utils/localization';
import { RegisterFormFields } from './types';

export interface PersonalDetailsProps {
  form: UseForm.Form<RegisterFormFields>;
}

export const PersonalDetails: React.FC<PersonalDetailsProps> = ({ form }) => {
  return (
    <>
      <InputText
        className="input-default--space"
        required
        autoComplete="given-name"
        name="user.first_name"
        type="text"
        placeholder={translate('form.fields.user.first_name.label')}
        value={form.data.first_name.value}
        onChange={first_name => form.set({ first_name })}
        meta={{
          error: form.getError('first_name'),
          showError: form.data.first_name.isDirty,
        }}
      />
      <InputText
        className="input-default--space"
        required
        autoComplete="family-name"
        name="user.last_name"
        type="text"
        placeholder={translate('form.fields.user.last_name.label')}
        value={form.data.last_name.value}
        onChange={last_name => form.set({ last_name })}
        meta={{
          error: form.getError('last_name'),
          showError: form.data.last_name.isDirty,
        }}
      />
      <InputText
        className="input-default--space"
        required
        autoComplete="email"
        name="user.email"
        type="email"
        placeholder={translate('form.fields.user.email.label')}
        value={form.data.email.value}
        onChange={email => form.set({ email })}
        meta={{
          error: form.getError('email'),
          showError: form.data.email.isDirty,
        }}
      />
      <InputPassword
        className="input-default--space"
        required
        autoComplete="new-password"
        name="user.new_password"
        placeholder={translate('form.fields.user.password.label')}
        value={form.data.new_password.value}
        onChange={new_password => form.set({ new_password })}
        meta={{
          error: form.getError('new_password'),
          showError: form.data.new_password.isDirty,
        }}
      />
      <InputText
        className="input-default--space"
        required
        autoComplete="tel"
        name="user.phone"
        type="tel"
        inputMode="numeric"
        placeholder={translate('form.fields.user.phone.label')}
        value={form.data.phone.value}
        onChange={phone => form.set({ phone })}
        meta={{
          error: form.getError('phone'),
          showError: form.data.phone.isDirty,
        }}
      />
      <InputCheckbox
        className="input-default--space"
        id="register-termsofuse"
        name="user.termsofuse"
        checked={form.data.termsofuse.value}
        onChange={() => form.set({ termsofuse: !form.data.termsofuse.value })}
        label={translate('request_flow.delivery.agree_general_terms', {
          condition_link: (
            <a
              href={`https://www.brenger.nl/${getActiveLanguageSettings().labels.contentSite}/terms`}
              target={'_blank'}
              rel="noreferrer"
            >
              <Translate id={'request_flow.delivery.general_terms'} />
            </a>
          ),
        })}
        meta={{
          error: form.getError('termsofuse'),
          showError: form.data.termsofuse.isDirty,
        }}
      />
    </>
  );
};

export default PersonalDetails;
